export default __webpack_public_path__ + "static/media/fff1.b754fd0a.png";